import {FETCH_BANNERS_REQUEST, FETCH_BANNERS_SUCCES, FETCH_BANNERS_ERROR} from '../constants/Banners'
import { jsonGet, errorHandler } from '../utils/Request';

const loadBanners = () => (dispatch) => {
  const apiUrl = '/banner/list/';
  dispatch({
    type: FETCH_BANNERS_REQUEST,
  });
  return jsonGet(apiUrl)
    .then(json => {
      dispatch({
        type: FETCH_BANNERS_SUCCES,
        payload: json,
      });
    })
    .catch((e) => {
      dispatch({
        type: FETCH_BANNERS_ERROR
      });
      errorHandler(e);
    });
};

export { loadBanners };



// WEBPACK FOOTER //
// ./src/actions/BannersActions.js